import { render, staticRenderFns } from "./data2.vue?vue&type=template&id=8ef403fa&"
import script from "./data2.vue?vue&type=script&lang=js&"
export * from "./data2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports